import {
  createContext,
  ReactNode,
  useContext,
  useState,
} from "react";

interface SystemProps {
  isMobile: boolean,
  
  updateMobile: (isMobile: boolean) => void
}

const SystemContext = createContext<SystemProps | null>(null);

export const SystemProvider = ({ children }: { children: ReactNode }) => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 800 ? true : false)

  const updateMobile = (isMobile: boolean) => {
    setIsMobile(isMobile)
  }

  return (
    <SystemContext.Provider
      value={{
        isMobile,
        updateMobile,
      }}
    >
      {children}
    </SystemContext.Provider>
  );
};

export const useSystemInfo = () => {
  return (
    useContext(SystemContext) || {
      isMobile: false,

      updateMobile: (isMobile: boolean) => {},
    } as SystemProps
  );
};
